import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  _theme => ({
    unlockCardsContainer: {
      "& > div:not(:last-child)": {
        marginBottom: 24
      }
    }
  }),
  { name: "CouponUnlockCodes" }
);

export default useStyles;
